(function () {
    "use strict";

    // @ngInject
    function ToolsMobileControllerCtor($injector, $scope, Enums, UsersManager, UserService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ToolsMobileController';
        this.user = UsersManager.getCurrUser();

        this.showNewTools = UserService.showToolsByCategory(this.user);
    }

    Controllers.ToolsMobileController = Class(Controllers.BaseController, {
        constructor: ToolsMobileControllerCtor
    });
}());

